import { I18n } from 'aws-amplify'

export const getPredefinedQuestions = () => [
  {
    id: 1,
    text: I18n.get('What are the key differences between greenhouse A and B?')
  },
  { id: 2, text: I18n.get('When was the first harvest date?') },
  { id: 3, text: I18n.get('What is the current growth status?') },
  { id: 4, text: I18n.get('Compare Iyris-treated plants to control group.') }
]

export const getAnswers = () => ({
  1: I18n.get(
    'Greenhouse A uses SecondSky polycarbonate with low blocking, while Greenhouse B uses standard plastic with polycarbonate. The main difference is in light transmission characteristics.'
  ),
  2: I18n.get(
    'The initial harvest began on February 12, 2025. The plants in Greenhouse A started producing slightly earlier than those in Greenhouse B.'
  ),
  3: I18n.get(
    'Plants are currently in production phase. All plants have developed 3-4 fruit bunches with the first bunch fully ripened and harvested.'
  ),
  4: I18n.get(
    'Iyris-treated plants demonstrated earlier flowering (by approximately 4 days), thicker stems (increased diameter of 12%), and shorter internodes compared to the control group, as observed on February 10, 2025.'
  )
})

export const getAudioPath = (lang = 'en') =>
  `/trial-mode/audio/trial-notebook-exec-summary-audio-${lang}.wav`
